import Vue from 'vue'
import {http} from "@/axios"
import makeNotificationSound from '@/helpers/makeNotificationSound'

function getInitState() {
  return {
    pending: false,
    loaded: false,
    open: false,
    newNotificationCount: 0,
    notificationsNew: [],
    notificationsViewed: [],
  }
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    clearState(state) {
      state.notificationsNew = []
      state.notificationsViewed = []
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      state[key] = value
    },
    deleteOne(state, index) {
      Vue.delete(state.notifications, index)
      state.newNotificationCount = state.notifications.length
    },
    openNotifications(state) {
      state.open = true
    },
    closeNotifications(state) {
      state.open = false
    }
  },
  actions: {
    load({state, commit, dispatch}) {
      if (state.loaded) return Promise.resolve()

      commit('setProperty', ['pending', true])

      return http.get('api/notifies',).then(({data}) => {
        if (data.data === false) return

        commit('setProperty', ['notificationsNew', data.data.not_viewed_notifies])
        commit('setProperty', ['notificationsViewed', data.data.viewed_notifies])
        commit('setProperty', ['newNotificationCount', data.data.not_viewed_notifies.length || 0])

        if(state.open) {
          dispatch('markAsRead')
        }
      }).finally(() => {
        commit('setProperty', ['pending', false])
      })
    },
    deleteOne({state, commit}, index) {
      const id = state.notifications[index].id
      commit('setProperty', ['pending', true])

      return http.patch(`/api/notifies/${id}`).then(() => {
        commit('deleteOne', index)
      }).finally(() => {
        commit('setProperty', ['pending', false])
      })
    },
    markAsRead({commit}) {
      return http.patch(`/api/notifies`).then(() => {
        commit('setProperty', ['newNotificationCount', 0])
      })
    },
    subscriberOnNotification({commit, state, rootState, dispatch}) {
      this.dispatch('user/userPusher/createPusher')

      dispatch('unSubscribeOnNotification')

      const channel = rootState.user.userPusher.channel
      channel.bind('new-notify', ({notify_count}) => {
        makeNotificationSound()
        commit('setProperty', ['newNotificationCount', notify_count || 0])
        if(state.open) {
          dispatch('load')
        }

        commit('setProperty', ['loaded', false])
      })
    },
    unSubscribeOnNotification({rootState}) {
      const channel = rootState.user.userPusher.channel
      if (!channel) return
      channel.unbind('new-notify')
    }
  }
}